import { useState } from 'react';

// taken from https://stackoverflow.com/a/53837442/618726
export default function useForceUpdate()
{
	const [value, setValue] = useState(0); // integer state
	return () => setValue(value + 1); // update the state to force render
}